import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import style from "./index.module.scss";
import WrapperContent from "../../shared/WrapperContent";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import CloseIcon from "../../shared/icons/CloseIcon";
import InputCustom from "../../shared/forms/input-custom";
import UserIcon from "../../shared/icons/UserIcon";
import PhoneIcon from "../../shared/icons/PhoneIcon";
import EmailIcon from "../../shared/icons/EmailIcon";
import { Employee } from '../../../services';
import { requestErrorDisplay } from '../../../utils';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import Loading from '../../shared/Loading/Loading';
import cn from 'classnames';
import SelectCustom from '../../shared/forms/select-custom';

const PHONE_MASK = '+79999999999';

const WorkersEditPage = () => {
  const { t } = useTranslation();
  const { user } = useSelector(state => state);
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const driversUrl = "/workers";
  const backUrl = searchParams.get("redirectUrl") ? searchParams.get("redirectUrl") : driversUrl;
  const [isLoading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [surname, setSurName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  // const [role, setRole] = useState("");
  const [status, setStatus] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [employeeData, setEmployeeData] = useState({});

  const ROLES = [
    { title: t('workersEditPage.roles.employee'), value: 'Employee' },
    { title: t('workersEditPage.roles.admin'), value: 'Admin' },
  ];
  const STATUS = [
    { title: t('workersEditPage.statuses.active'), value: 'Confirmed' },
    { title: t('workersEditPage.statuses.inactive'), value: 'UnActive' },
  ];

  useEffect(() => {
    if (id) {
      loadEmployeeData(id);
    }
  }, [id]);

  const loadEmployeeData = async (employeeId) => {
    try {
      const response = await Employee.getEmployee(employeeId);
      // setEmployeeData(response.data);
      setName(response.data.name);
      setSurName(response.data.surname);
      setEmail(response.data.email);
      setPhoneNumber(response.data.phoneNumber);
      // setRole(response.data.role);
      setStatus(response.data.state);

      const selectedRoleObject = ROLES.find(role => role.value.toLowerCase() === response.data.role.toLowerCase());
      setSelectedRole(selectedRoleObject);
      const selectedStatusObject = STATUS.find(status => status.value.toLowerCase() === response.data.state.toLowerCase());
      setSelectedStatus(selectedStatusObject);
    } catch (error) {
      console.error('Ошибка при загрузке данных сотрудника:', error);
    }
  };

  const validateFormatData = () => {
    if (!name) {
      toast.error(t('workersEditPage.validation.invalidName'));
      return false;
    }

    if (!surname) {
      toast.error(t('workersEditPage.validation.invalidLastName'));
      return false;
    }

    if (!email) {
      toast.error(t('workersEditPage.validation.invalidEmail'));
      return false;
    }

    // if (!phoneNumber) {
    //   toast.error("Не корректно заполнено поле номер телефона")
    //   return false
    // }

    // if (!role) {
    //   toast.error("Выберите роль сотрудника");
    //   return false;
    // }

    return true;
  }

  const onSubmit = async () => {
    if (!validateFormatData()) {
      return;
    }

    const updatedData = {
      name: name,
      surname: surname,
      patronymic: "",
      iin: "",
      phoneNumber: phoneNumber,
      // role: role,
      state: status
    };

    Employee.editEmployee(id, updatedData)
      .then(res => {
        setLoading(true)
        if (res.status === 200) {
          toast.success(t('workersEditPage.toast.updateSuccess'));
          navigate(backUrl)
          return res.data;
        } else {
          toast.error(t('workersEditPage.toast.updateError'));
        }
      })
      .catch(error => {
        requestErrorDisplay(error)
      })
      .finally(() => {
        setLoading(false)
      })
  };

  return (
    <WrapperContent>
      <div className={style.wrapper}>
        <h1 className={style.title}>{t('workersEditPage.title')}</h1>
        <div className={style.content}>
          <div className={style.field}>
            <span className={style.field_label}>{t('workersEditPage.name.label')}</span>
            <InputCustom
              placeholder={t('workersEditPage.name.placeholder')}
              defaultValue={name}
              onChangeValue={setName}
              isDisabled={true}
              prefixStart={<UserIcon />}
            />
          </div>
          <div className={style.field}>
            <span className={style.field_label}>{t('workersEditPage.lastName.label')}</span>
            <InputCustom
              placeholder={t('workersEditPage.lastName.placeholder')}
              defaultValue={surname}
              onChangeValue={setSurName}
              isDisabled={true}
              prefixStart={<UserIcon />}
            />
          </div>
          {/* <div className={style.field}>
            <span className={style.field_label}>{t('workersEditPage.role.label')}</span>
            <SelectCustom
              key={'title'}
              placeholder={t('workersEditPage.role.placeholder')}
              keyId="value"
              keyName="title"
              options={ROLES}
              defaultValue={selectedRole}
              returnObject
              onSubmit={(item) => {
                console.log("item", item)
                setRole(item.value)
                setSelectedRole(item);
              }}
            />
          </div> */}
          <div className={style.field}>
            <span className={style.field_label}>{t('workersEditPage.email.label')}</span>
            <InputCustom
              defaultValue={email}
              onChangeValue={setEmail}
              placeholder={t('workersEditPage.email.placeholder')}
              isDisabled={true}
              prefixStart={<EmailIcon />}
            />
          </div>
          <div className={style.field}>
            <span className={style.field_label}>{t('workersEditPage.phone.label')}</span>
            <InputMask
              value={phoneNumber}
              maskChar={null}
              mask={PHONE_MASK}
              onChange={(event) => setPhoneNumber(event.target.value)}
              disabled={false}
            >
              {(inputProps) => (
                <InputCustom
                  {...inputProps}
                  placeholder={PHONE_MASK}
                  prefixStart={<PhoneIcon />}
                  defaultValue={phoneNumber}
                  onChangeValue={setPhoneNumber}
                />
              )}
            </InputMask>
          </div>
          <div className={style.field}>
            <span className={style.field_label}>{t('workersEditPage.status.label')}</span>
            <SelectCustom
              key={'countries-from'}
              placeholder={t('workersEditPage.status.placeholder')}
              keyId="value"
              keyName="title"
              isDisabled={status === 'Draft'}
              options={STATUS}
              defaultValue={selectedStatus}
              returnObject
              onSubmit={(item) => {
                console.log("item", item)
                setStatus(item.value)
                setSelectedStatus(item)
              }}
            />
          </div>

          <Link to={backUrl} className={style.buttonClose}>
            <CloseIcon />
          </Link>
        </div>
        <div className={style.block}>
          <Link to={backUrl} className={style.buttonCancel}>
            {t('workersEditPage.buttons.cancel')}
          </Link>

          <button
            className={cn(style.button_upload, { [style.button_upload_loading]: isLoading })}
            onClick={() => onSubmit()}
          >
            {!isLoading && <span>{t('common.save')}</span>}
            {isLoading && <Loading inBlock marginBottom={0} />}
          </button>
        </div>
      </div>
    </WrapperContent>
  );
};

export default WorkersEditPage;
